import React from 'react'

/** Subtitles glyph. Hand-drawn to match the heroicons outline set, which has no captions icon. */
export const CaptionsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
    <path d="M10 10.25a2.25 2.25 0 1 0 0 3.5" />
    <path d="M17 10.25a2.25 2.25 0 1 0 0 3.5" />
  </svg>
)

export default CaptionsIcon
